import { useMemo } from 'react';
import { DataTable } from '@/components/ui/DataTable';
import { formatTableCellValue, humanizeColumnKey } from '@/utils/tableCellValue';

interface KeyValueTableProps {
  data: Record<string, unknown> | null | undefined;
  embedded?: boolean;
  emptyTitle?: string;
}

/** Renders a configuration / summary object as a two-column table. */
export function KeyValueTable({
  data,
  embedded,
  emptyTitle = 'No data',
}: KeyValueTableProps) {
  const rows = useMemo(() => {
    if (!data) return [];
    return Object.entries(data).map(([field, value]) => ({
      field: humanizeColumnKey(field),
      value: formatTableCellValue(value),
    }));
  }, [data]);

  return (
    <DataTable
      columns={[
        { key: 'field', header: 'Field' },
        { key: 'value', header: 'Value' },
      ]}
      data={rows}
      keyField="field"
      embedded={embedded}
      emptyTitle={emptyTitle}
    />
  );
}
